export const h = {
  connectYourDevice: 'Connect your device',
  mainTips: 'A list of devices will open below the URL bar, select a device, and click the "Connect" button.',
  presentationMode: 'Presentation mode',
  browserVersionTips: 'The current {n} browser version is too low, please upgrade to the latest version!',
  browserVersionTips2: 'The current browser does not support it, please use the latest version of Chrome, Edge or Opera!',
  reconnectedTipsTitle: 'If a device is detected to be reconnected, do you want to go to the corresponding device page?',
  reconnectedTipsHead: 'Tips',
  sure: 'Sure',
  cancel: 'Cancel',
  disconnect: 'The device is disconnected',
  connectFail: 'The device fails to connect, plug and unplug the device and reconnect it!'
}